<template>
  <component :is="componentType">
    <div
      class="container section-bg py-0"
      :style="bgImage"
      :class="{ 'spa-lazy': bgImageLazy }"
      :data-background-image="dataBgImage">
      <div class="row px-space-xxs px-md-space-lg py-space-lg">
        <div class="col-12 col-lg-4">
          <div :class="bgColorClass">
            <div class="py-space-sm py-md-space-lg px-space-sm px-md-space-md">
              <component
                class="mb-space-sm"
                :is="titleLevel"
                :class="titleClass">
                {{ title }}
              </component>
              <slot name="text"></slot>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8 px-space-xs px-md-space-md py-space-lg">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import lozad from "lozad";
import { computed, onMounted } from "vue";

interface Props {
  componentType?: "section" | "div";
  title: string;
  titleSize?: string;
  titleVariant?: string;
  titleLevel: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  bgImageSource: string;
  bgImageLazy: boolean;
  bgVariant?: string;
}

const props = withDefaults(defineProps<Props>(), {
  componentType: "section",
  title: "Lorem ipsum",
  titleSize: "medium",
  titleVariant: "dark-3",
  titleLevel: "h2",
  bgImageSource:
    "https://live-asuocms.ws.asu.edu/sites/default/files/Topo%20dark%20background%20pattern%402x.jpg",
  bgImageLazy: true,
  bgVariant: "white",
});

const titleClass = computed(() => {
  return `${props.titleLevel}-${props.titleSize} text-${props.titleVariant}`;
});

const bgImage = computed(() => {
  if (!props.bgImageLazy) {
    return {
      "background-image": `url('${props.bgImageSource}')`,
    };
  } else {
    return null;
  }
});

const dataBgImage = computed(() => {
  return props.bgImageLazy ? props.bgImageSource : null;
});

const bgColorClass = computed(() => {
  return `bg-${props.bgVariant}`;
});

onMounted(() => {
  if (props.bgImageLazy) {
    const observer = lozad(".spa-lazy");
    observer.observe();
  }
});
</script>

<style lang="scss" scoped></style>
